import { SETTINGS_ROUTE } from "../../constants/appRoutes";
import { AppManager } from "..";
import { IOEventTypes } from "../RealtimeManager";

export class DGroupNetworkHelper {
    static networkDataReceived = <K extends keyof IOEventTypes>(evt: K, resp: any): void => {
        switch (evt) {
            case "DEALER_GROUP_UPDATED":
                {
                    const dGroup = (resp as IOEventTypes["DEALER_GROUP_UPDATED"]).data;
                    AppManager.dealerGroup.hydrateFullOrganization(dGroup, false);
                }
                break;
        }
    };

    static onConnectionRestoredSync(currentRoute: string, currentPathName: string) {
        switch (currentRoute) {
            case SETTINGS_ROUTE:
                AppManager.org.refreshActiveOrganization();
                break;
        }
    }
}
